import React, { Fragment } from "react";
import { MainPagesSectionHeader } from "./components/MainPagesSectionHeader";
import { Map, Marker, Overlay } from "pigeon-maps";

const branches: { name: string; position: [number, number] }[] = [
  { name: "Urban", position: [21.019557, -89.595265] },
  { name: "Montejo", position: [21.002827, -89.614862] },
  { name: "The Harbor", position: [21.046215, -89.630306] },
];

const mapCenter: [number, number] = [21.019557, -89.613934];

export const MainPagesContact = () => {
  return (
    <Fragment>
      <section className="u-bgPrimaryLightest u-pb-6r u-pt-10r">
        <div className="container">
          <MainPagesSectionHeader title="Contacto" />
          <div>
            <div className="mb-5">
              <Map
                height={400}
                center={mapCenter}
                zoom={12}
                attribution={false}
              >
                {branches.map((branch, index) => (
                  <Marker
                    key={index}
                    anchor={branch.position}
                    color="#0e368d"
                    onClick={() => {}}
                  />
                ))}
                {branches.map((branch, index) => (
                  <Overlay
                    key={`overlay-${index}`}
                    anchor={branch.position}
                    offset={[0, 50]}
                  >
                    <div
                      style={{
                        background: "white",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        fontSize: "12px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                        whiteSpace: "nowrap",
                        transform: "translateX(-50%)",
                      }}
                    >
                      {branch.name}
                    </div>
                  </Overlay>
                ))}
              </Map>
            </div>
          </div>
          <div className="branchesWrapper">
            <div className="branchCard c-card u-bgPrimaryLighter u-textWhite">
              <p className="branchCard c-card_title">Urban</p>
              <p>
                <i className="branchCard_icon fas fa-phone"></i> 999 406 9174
              </p>
              <p>
                <i className="branchCard_icon fab fa-whatsapp-square"></i>{" "}
                <a
                  className="u-textWhite"
                  href="https://wa.me/5219991841434"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +52 1 999 184 1434
                </a>
              </p>
              <p>
                <i className="branchCard_icon fas fa-thumbtack"></i> Av. Cámara
                de Comercio 215, Monterreal
              </p>
            </div>
            <div className="branchCard c-card u-bgPrimaryLighter u-textWhite">
              <p className="branchCard c-card_title">Harbor</p>
              <p>
                <i className="branchCard_icon fas fa-phone"></i> 999 925 0015
              </p>
              <p>
                <i className="branchCard_icon fab fa-whatsapp-square"></i>{" "}
                <a
                  className="u-textWhite"
                  href="https://wa.me/5219991841434"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +52 1 999 184 1434
                </a>
              </p>
              <p>
                <i className="branchCard_icon fas fa-thumbtack"></i> Calle 60
                261, Zona Industrial
              </p>
            </div>
            <div className="branchCard c-card u-bgPrimaryLighter u-textWhite">
              <p className="branchCard c-card_title">Montejo</p>
              <p>
                <i className="branchCard_icon fas fa-phone"></i> 999 400 7974
              </p>
              <p>
                <i className="branchCard_icon fab fa-whatsapp-square"></i>{" "}
                <a
                  className="u-textWhite"
                  href="https://wa.me/5219991841434"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +52 1 999 184 1434
                </a>
              </p>
              <p>
                <i className="branchCard_icon fas fa-thumbtack"></i> Prol. Paseo
                Montejo 99, Campestre
              </p>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
